import { render, staticRenderFns } from "./SpecialOfferSingleItem.vue?vue&type=template&id=f5c31042&scoped=true&"
import script from "./SpecialOfferSingleItem.vue?vue&type=script&lang=ts&"
export * from "./SpecialOfferSingleItem.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialOfferSingleItem.vue?vue&type=style&index=0&id=f5c31042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c31042",
  null
  
)

export default component.exports